import authService from "../services/auth";
import i18n from "../i18n";

export default {
    namespaced: true,
    state: {
        auth: null,
        user: null,
        points: null,
        invites: null,
        projects: null,
        carts: null,
        status: null,
        onboardingProjects: null,
    },
    getters: {
        accessToken(state) {
            return state.auth ? state.auth.access_token : null;
        },
        refreshToken(state) {
            return state.auth ? state.auth.refresh_token : null;
        },
        isLoggedIn(state) {
            return state.auth ? true : false;
        },
        auth(state) {
            return state.auth;
        },
        user(state) {
            return state.user;
        },
        points(state) {
            return state.points;
        },
        invites(state) {
            return state.invites;
        },
        projects(state) {
            if (Array.isArray(state.projects) === false) {
                return [];
            }

            return state.projects.filter(function(u) {
                return u.onboarding !== 1;
            });

        },
        onboardingProjects(state) {
            if (Array.isArray(state.projects) === false) {
                return [];
            }

            return state.projects.filter(function(u) {
                return u.onboarding == 1;
            });

        },

        carts(state) {
            return state.carts;
        },
        status(state) {
            return state.status;
        }        
    },
    mutations: {
        auth(state, auth) {
            localStorage.setItem('auth', JSON.stringify(auth)); 
            state.auth = auth;
        },
        user(state, user) {
            state.user = user;
        },
        points(state, points) {
            state.points = points;
        },
        invites(state, invites) {
            state.invites = invites;
        },
        projects(state, projects) {
            state.projects = projects;
        },
        carts(state, carts) {
            state.carts = carts;
        },
        status(state, status) {
            state.status = status;
        }
                           
    },
    actions: {
        login(context, credentials) {
            return new Promise((resolve, reject) => {
                authService
                    .login(credentials)
                    .then(response => {
                        this.commit("user/auth", response);
                        this.dispatch("user/userinfo")
                            .then(response => {
                                resolve(response);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        refresh(context) {
            return new Promise((resolve, reject) => {
                authService
                    .refresh(context.getters.refreshToken)
                    .then(response => {
                        this.commit("user/auth", response);
                        resolve(response);
                    })
                    .catch(error => {
                        this.commit("user/auth", null);
                        reject(error);
                    });
            });
        },
        userinfo() {
            return new Promise((resolve, reject) => {
                let lang = i18n.locale;
                authService
                    .userinfo(lang)
                    .then(response => {
                        this.commit("user/user", response['user']);
                        this.commit("user/points", response['points']);
                        this.commit("user/invites", response['invites']);
                        this.commit("user/projects", response['projects']);
                        this.commit("user/projects", response['projects']);       
                        this.commit("user/carts", response['cart']);
                        this.commit("user/status", response['status']);                        
                        resolve();
                    })
                    .catch(error => {
                        this.commit("user/user", null);
                        this.commit("user/points", null);
                        this.commit("user/invites", null);
                        this.commit("user/projects", null);
                        this.commit("user/carts", null);
                        this.commit("user/status", null);                        
                        reject(error);
                    });
            });
        },
        points() {
            return new Promise((resolve, reject) => {
                authService
                    .points()
                    .then(response => {
                        this.commit("user/points", response);
                        resolve(response);
                    })
                    .catch(error => {
                        this.commit("user/points", null);
                        reject(error);
                    });
            });
        },
        invites() {
            return new Promise((resolve, reject) => {
                authService
                    .invites()
                    .then(response => {
                        this.commit("user/invites", response);
                        resolve(response);
                    })
                    .catch(error => {
                        this.commit("user/invites", null);
                        reject(error);
                    });
            });
        },
        projects() {
            return new Promise((resolve, reject) => {
                authService
                    .projects()
                    .then(response => {
                        this.commit("user/projects", response);
                        resolve(response);
                    })
                    .catch(error => {
                        this.commit("user/projects", null);
                        reject(error);
                    });
            });
        },
        carts() {
            return new Promise((resolve, reject) => {
                let lang = i18n.locale;
                authService
                    .carts(lang)
                    .then(response => {
                        this.commit("user/carts", response);
                        resolve(response);
                    })
                    .catch(error => {
                        this.commit("user/carts", null);
                        reject(error);
                    });
            });
        },
        logout() {
            //TODO: revoke token
            this.commit("user/auth", null);
            this.commit("user/user", null);
            this.commit("user/points", null);
            this.commit("user/invites", null);
            this.commit("user/projects", null);
            this.commit("user/onboardingProjects", null);            
            this.commit("user/carts", null);
            this.commit("user/status", null);
        }
    }
};
